/**
 * <pdp-read-more>: clips long product descriptions to data-collapsed-height.
 * The toggle only appears when the content is taller than the limit plus a
 * little slack, so a description one line too long is shown in full instead.
 */
if (!customElements.get('pdp-read-more')) {
  customElements.define(
    'pdp-read-more',
    class PdpReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.pdp-desc__content');
        this.button = this.querySelector('.pdp-desc__toggle');
        this.label = this.button?.querySelector('.pdp-desc__toggle-label');
        if (!this.content || !this.button) return;

        this.limit = parseInt(this.dataset.collapsedHeight, 10) || 200;
        this.expanded = false;

        this.onClick = this.toggle.bind(this);
        this.button.addEventListener('click', this.onClick);

        // A keyboard user tabbing onto a link in the clipped part gets the full text.
        this.onFocusIn = () => {
          if (this.classList.contains('is-collapsed')) this.toggle();
        };
        this.content.addEventListener('focusin', this.onFocusIn);

        this.measure = this.measure.bind(this);
        this.measure();
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.measure);
          this.observer.observe(this.content);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
        this.content?.removeEventListener('focusin', this.onFocusIn);
      }

      measure() {
        const needed = this.content.scrollHeight > this.limit + 48;
        this.button.hidden = !needed;
        this.classList.toggle('is-collapsible', needed);
        this.classList.toggle('is-collapsed', needed && !this.expanded);
      }

      toggle() {
        this.expanded = !this.expanded;
        this.classList.toggle('is-collapsed', !this.expanded);
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.label.textContent = this.expanded ? this.button.dataset.labelLess : this.button.dataset.labelMore;

        // After collapsing, bring the start of the description back into view.
        if (!this.expanded) {
          const top = this.closest('.pdp-desc')?.getBoundingClientRect().top ?? 0;
          if (top < 0) this.closest('.pdp-desc').scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }
  );
}
